<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13Y53c1/tc-custom/9781504081696.jpg?1728353158180" alt="This image is the cover for the book Fistful of Rain, The Ty Dawson Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fistful of Rain, The Ty Dawson Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>The second Sheriff Dawson mystery has “lots of twists and turns that stretch back over years, then a mind-blowing ending that puts everything into place” (<i>Killer Nashville</i>).</b><br/>  <br/><b>Winner—2019 Best Book of the Year, <i>Killer Nashville</i></b><br/>  <br/> Ty Dawson, now the sheriff of Oregon’s Meriwether County, is ready to put a trying year behind him, but he’s afforded no such luck. In a country still coming to grips with the Vietnam War, Watergate, and Charles Manson, Ty’s neck of the woods isn’t safe from the turmoil—especially when a commune of young so-called hippies springs up out of nowhere . . .<br/>  <br/> A longtime local sheep rancher accuses the Rainbow Ranch residents of livestock theft, putting Ty in the middle of a culture clash. Though Ty finds no evidence of a crime, the rancher brings in his own stock detective. Behind fences topped with razor wire, the commune and its enigmatic guru hold secrets of their own—many of which have nothing to do with peace, love, and understanding. Tensions flare, setting off a bloody wave of violence that will forever scar the place Ty calls home, unless he can stop it.<br/>  <br/><b>“Elegantly written . . . Ty may strike some readers as almost too smart, too well educated, and too pedantic for a small-town sheriff, but his insights into 1970s social issues make him an irresistible spokesman for the era.” —<i>Publishers Weekly</i></b><br/>  <br/><b>“A modern Western . . . The characters are well developed, and place descriptions make it easy to visualize the landscapes.” —<i>New York Journal of Books</i></b><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Baron Birtcher
      </h2>
      
      <p class="authorDescription body article"><P> Baron Birtcher spent a number of years as a professional musician, and founded an independent record label and management company. His first two novels, <I>Roadhouse Blues</I> and <I>Ruby Tuesday</I>, are <I>Los Angeles Times </I>and Independent Mystery Booksellers Association bestsellers. Birtcher has been nominated for a number of literary awards, including the Nero Award for his novel Hard Latitudes, the Claymore Award for his novel <I>Rain Dogs</I>, and the Left Coast Crime &ldquo;Lefty&rdquo; Award for his novel <I>Angels Fall</I>. He was the 2016 Silver Falchion Award winner for his novel Hard Latitudes and the 2018 Winner of the Killer Nashville Reader&rsquo;s Choice Award for his novel <I>South California Purples.</I></P><P> Birtcher currently divides his time between Portland, Oregon, and Kona, Hawaii. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?27a0974c